import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';

import styles from './index.styl';


function Erid(props) {
  const {
    theme: {
      fonts,
      layout,
      controls: {
        topicContent: {
          widgetsMaxWidth,
        },
      },
    },
    erid,
    maxWidth,
  } = props;

  if (!erid) return null;

  return (
    <div className={styles.erid}>
      <style jsx>{`
        .${styles.erid}
          font-family ${fonts.text}
          :global(.desktop) &
            max-width ${maxWidth || `${widgetsMaxWidth}px`}
          :global(.mobile) &
            max-width ${layout.maxWidth}
      `}</style>
      erid: {erid}
    </div>
  );
}

Erid.propTypes = {
  theme: PropTypes.object,
  erid: PropTypes.string,
  maxWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default withTheme(Erid);
